import { render, staticRenderFns } from "./mCategoryView.vue?vue&type=template&id=7c5d1cbf&scoped=true"
import script from "./mCategoryView.vue?vue&type=script&lang=js"
export * from "./mCategoryView.vue?vue&type=script&lang=js"
import style0 from "./mCategoryView.vue?vue&type=style&index=0&id=7c5d1cbf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5d1cbf",
  null
  
)

export default component.exports